import { ShopperSocialGroupJoinScanPage } from "./../shopper-social-group-join-scan/shopper-social-group-join-scan";
import { ShopperMissionPage } from "./../shopper-mission/shopper-mission";
import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ShopperMissionSocialDescPage } from "./../shopper-mission-social-desc/shopper-mission-social-desc";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-mission-social",
  templateUrl: "shopper-mission-social.html",
})
export class ShopperMissionSocialPage {
  lists: any;
  step: any;
  url: any;
  budget: any;
  theme = 2;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      this.storage.get("language").then((lang) => {
        var link = this.services.URLShopperMissions + "?lang=" + lang;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.lists = data;
              loader.dismiss();
            },
            (error) => {
              var response = JSON.parse(error._body);
              loader.dismiss();
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );

        this.storage.get("info").then((info) => {
          if (info.role == 1) {
            this.url = this.services.URLPlazaStatBudgets;
          } else if (info.role == 2) {
            this.url = this.services.URLMerchantStatBudgets;
          } else if (info.role == 3) {
            this.url = this.services.URLShopperStatBudgets;
          }
          var link = this.url;

          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.budget = this.services.currencyFormat(data.available);
              },
              (error) => {
                // console.log(error);
                this.services.presentToastInternet();
              }
            );
        });
      });
    });

    this.storage.get("currentStep").then((step) => {
      this.step = step;
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      this.storage.get("language").then((lang) => {
        var link = this.services.URLShopperMissions + "?lang=" + lang;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.lists = data;
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );

        this.storage.get("info").then((info) => {
          if (info.role == 1) {
            this.url = this.services.URLPlazaStatBudgets;
          } else if (info.role == 2) {
            this.url = this.services.URLMerchantStatBudgets;
          } else if (info.role == 3) {
            this.url = this.services.URLShopperStatBudgets;
          }
          var link = this.url;

          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                this.budget = this.services.currencyFormat(data.available);
              },
              (error) => {
                // console.log(error);
                this.services.presentToastInternet();
              }
            );
        });
      });
    });

    this.storage.get("currentStep").then((step) => {
      this.step = step;
    });

    refresher.complete();
  }

  missionDesc(
    mission_no,
    mission_text,
    social_group,
    leader_social_group,
    mission_member_status
  ) {
    this.navCtrl.push(ShopperMissionSocialDescPage, {
      id: mission_no,
      mission_text: mission_text,
      social_group: social_group,
      leader_social_group: leader_social_group,
    });
  }

  backPage() {
    this.navCtrl.push(ShopperMissionPage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }

  join(mission_no) {
    // console.log(mission_no);
    this.navCtrl.push(ShopperSocialGroupJoinScanPage, { mission_id: 0 });
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission-social/shopper-mission-social.ts